/**
 * InfoWindowContent
 */

import React from 'react';

import Button from 'components/Button';
import InfoBox from 'components/InfoBox';
import Status from 'components/Status';
import { StockStatus } from 'components/Stock';
import Text from 'components/Text';

export interface Props {
	address: string;
	availableStockLevelText: string | undefined;
	inStock: boolean | undefined;
	isOpen: boolean | undefined;
	isSelected: boolean;
	isSelectedMessage: string;
	linkText: string;
	linkUrl: string | undefined;
	onSelectClick: () => void;
	openHours: string | undefined;
	selectButtonText: string;
	storeArea: string;
}

/** The content for a map info window */
export default function InfoWindowContent({
	address,
	availableStockLevelText,
	inStock,
	isOpen,
	isSelected,
	isSelectedMessage,
	linkText,
	linkUrl,
	onSelectClick,
	openHours,
	selectButtonText,
	storeArea,
}: Props) {
	return (
		<div className="p-1">
			<Text as="p" text={storeArea} />
			<Text as="p" text={address} className="mb-2" />
			{availableStockLevelText && inStock && (
				<StockStatus
					textSize="small"
					inStock={inStock}
					text={availableStockLevelText}
				/>
			)}
			{openHours && (
				<Status color={isOpen ? 'green' : 'red'} text={openHours} />
			)}
			<div className="my-4">
				{!isSelected && (
					<Button onClick={onSelectClick} displayWidth="full" variant="cta">
						{selectButtonText}
					</Button>
				)}
				{isSelected && (
					<InfoBox icon="check" variant="success" message={isSelectedMessage} />
				)}
			</div>
			{linkUrl && (
				<Button variant="secondary" displayWidth="full" href={linkUrl}>
					{linkText}
				</Button>
			)}
		</div>
	);
}
InfoWindowContent.displayName = 'InfoWindowContent';
